/**
 * Environment Configuration
 * 
 * This module provides centralized access to environment-specific configuration.
 * Values can be overridden by setting environment variables.
 */

// API Endpoints
const API_ENDPOINTS = {
  // Development environment endpoints
  development: {
    FLOORPLAN_DESIGN_API: process.env.REACT_APP_FLOORPLAN_API || 'http://127.0.0.1:5001/floorplan/inner-design',
  },
  // Staging environment endpoints
  staging: {
    FLOORPLAN_DESIGN_API: process.env.REACT_APP_FLOORPLAN_API || 'https://staging.ai-structure.com/aistructure-api-v2/floorplan/inner-design',
  },
  // Production environment endpoints
  production: {
    FLOORPLAN_DESIGN_API: process.env.REACT_APP_FLOORPLAN_API || 'https://ai-structure.com/aistructure-api-v2/floorplan/inner-design',
  }
};

/**
 * Get the current environment
 * @returns {string} Current environment (development, staging, or production)
 */
export function getCurrentEnvironment() {
  return process.env.NODE_ENV || 'development';
}

/**
 * Get configuration for the current environment
 * @returns {Object} Environment configuration
 */
export function getEnvironmentConfig() {
  const env = getCurrentEnvironment();
  return API_ENDPOINTS[env] || API_ENDPOINTS.development;
}

/**
 * Get a specific API endpoint for the current environment
 * @param {string} endpoint - The endpoint key
 * @returns {string} The API endpoint URL
 */
export function getApiEndpoint(endpoint) {
  const config = getEnvironmentConfig();
  return config[endpoint];
}

// Export the specific endpoints
export const ENDPOINTS = {
  FLOORPLAN_DESIGN_API: 'FLOORPLAN_DESIGN_API'
}; 
